{
  "Accessibility Menu": "Tillgänglighetsmeny",
  "Reset settings": "Nollställ inställningar",
  "Close": "Stäng",
  "Content Adjustments": "Anpassa innehåll",
  "Adjust Font Size": "Justera textstorlek",
  "Highlight Title": "Framhäv titel",
  "Highlight Links": "Framhäv länkar",
  "Readable Font": "Läsbart teckensnitt",
  "Color Adjustments": "Anpassa färger",
  "Dark Contrast": "Mörk kontrast",
  "Light Contrast": "Ljus kontrast",
  "High Contrast": "Hög kontrast",
  "High Saturation": "Hög mättnad",
  "Low Saturation": "Låg mättnad",
  "Monochrome": "Monokrom",
  "Tools": "Verktyg",
  "Reading Guide": "Läslinjal",
  "Stop Animations": "Hindra animationer",
  "Big Cursor": "Stor muspekare",
  "Increase Font Size": "Öka textstorlek",
  "Decrease Font Size": "Minska textstorlek",
  "Letter Spacing": "Teckenavstånd",
  "Line Height": "Radhöjd",
  "Font Weight": "Teckensnitt tjocklek",
  "Dyslexia Font": "Dyslektiskt teckensnitt",
  "Language": "Språk",
  "Open Accessibility Menu": "Öppna tillgänglighetsmeny",
  "Accessibility Profiles": "Tillgänglighetsprofiler",
  "Seizure Safe Profile": "Profil säker för epilepsi",
  "Stops animations and reduces color saturation.": "Stoppar animationer och minskar färgmättnad.",
  "Blind Profile": "Profil för blinda",
  "Activates the screen reader for auditory navigation.": "Aktiverar skärmläsare för auditiv navigering.",
  "Visually Impaired Profile": "Profil för synskadade",
  "Enhances contrast and readability for low vision.": "Förbättrar kontrast och läsbarhet för nedsatt syn.",
  "ADHD Friendly Profile": "Profil anpassad för ADHD",
  "Reduces distractions for better focus.": "Minskar störande moment för bättre fokus.",
  "Cognitive & Learning Profile": "Kognitiv och lärandeprofil",
  "Helpful tools for reading and comprehension.": "Användbara verktyg för läsning och förståelse.",
  "Motor Impaired Profile": "Profil för motoriskt handikappade",
  "Optimizes the site for keyboard-only navigation.": "Optimerar sidan för navigering med endast tangentbord.",
  "Headings": "Rubriker",
  "Landmarks": "Landmärken",
  "Links": "Länkar",
  "Focus element": "Fokuselement",
  "Visit link": "Besök länk"
}